export const addBetOption = (betOptions, option) => {
  const existingItem = betOptions?.find((item) => item === option);
  if (existingItem) {
    return betOptions.filter((item) => item !== option);
  }
  return [...betOptions, option];
};
